


export class CSSHexColor
{
  hexValue:string;

  toString()
  {
    return `#${this.hexValue}`;
  }
}

class CSSColorBase
{
  a:number;
}

export class CSSRGBColor extends CSSColorBase
{
  r:number;
  g:number;
  b:number;

  constructor( r:number, g:number, b:number, a:number = 1 )
  {
    super();
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  toString()
  {
    return `rgb(${this.r},${this.g},${this.b},${this.a})`;
  }
}

export class CSSHSLColor extends CSSColorBase
{
  h:number;
  s:number;
  l:number;

  constructor( h:number, s:number, l:number, a:number = 1 )
  {
    super();
    this.h = h;
    this.s = s;
    this.l = l;
    this.a = a;
  }

  toString()
  {
    return `hsl(${this.h},${this.s}%,${this.l}%,${this.a})`;
  }
}

export type CSSColor = CSSHexColor | CSSRGBColor | CSSHSLColor;